/* RESPONSIBLE TEAM: team-ai-agent */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentGuidanceV2ChatRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentGuidanceV2ChatRoute, {
  overrideRenderTemplate: false,
});
